
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire3512"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire3512"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $kseh8 = parcelRequire("kseh8");
parcelRequire("8pGV4");

var $7D21u = parcelRequire("7D21u");


var $kseh8 = parcelRequire("kseh8");

var $8pGV4 = parcelRequire("8pGV4");

var $kseh8 = parcelRequire("kseh8");

var $c9Xf9 = parcelRequire("c9Xf9");
var $424c5cdc8cac8172$exports = {};

$parcel$export($424c5cdc8cac8172$exports, "calendarCard", function () { return $424c5cdc8cac8172$export$c57e90396a5fdda5; }, function (v) { return $424c5cdc8cac8172$export$c57e90396a5fdda5 = v; });
$parcel$export($424c5cdc8cac8172$exports, "calendarContainer", function () { return $424c5cdc8cac8172$export$761099f155521a60; }, function (v) { return $424c5cdc8cac8172$export$761099f155521a60 = v; });
$parcel$export($424c5cdc8cac8172$exports, "calendarWrapper", function () { return $424c5cdc8cac8172$export$c30e453142468ef3; }, function (v) { return $424c5cdc8cac8172$export$c30e453142468ef3 = v; });
$parcel$export($424c5cdc8cac8172$exports, "contentShow", function () { return $424c5cdc8cac8172$export$80b267e3ef38fe4a; }, function (v) { return $424c5cdc8cac8172$export$80b267e3ef38fe4a = v; });
$parcel$export($424c5cdc8cac8172$exports, "dialogContent", function () { return $424c5cdc8cac8172$export$1a09c8e9a482a512; }, function (v) { return $424c5cdc8cac8172$export$1a09c8e9a482a512 = v; });
$parcel$export($424c5cdc8cac8172$exports, "dialogOverlay", function () { return $424c5cdc8cac8172$export$fd1af5f6d2c0dae1; }, function (v) { return $424c5cdc8cac8172$export$fd1af5f6d2c0dae1 = v; });
$parcel$export($424c5cdc8cac8172$exports, "errorForm", function () { return $424c5cdc8cac8172$export$7aec1c0a952f8449; }, function (v) { return $424c5cdc8cac8172$export$7aec1c0a952f8449 = v; });
$parcel$export($424c5cdc8cac8172$exports, "errorMessage", function () { return $424c5cdc8cac8172$export$493b5823483d2c4e; }, function (v) { return $424c5cdc8cac8172$export$493b5823483d2c4e = v; });
$parcel$export($424c5cdc8cac8172$exports, "errorMessageDescription", function () { return $424c5cdc8cac8172$export$4b66c84692c39e67; }, function (v) { return $424c5cdc8cac8172$export$4b66c84692c39e67 = v; });
$parcel$export($424c5cdc8cac8172$exports, "errorMessageTitle", function () { return $424c5cdc8cac8172$export$8b9bf0a5c2438d10; }, function (v) { return $424c5cdc8cac8172$export$8b9bf0a5c2438d10 = v; });
$parcel$export($424c5cdc8cac8172$exports, "form", function () { return $424c5cdc8cac8172$export$6210fa4921d2a466; }, function (v) { return $424c5cdc8cac8172$export$6210fa4921d2a466 = v; });
$parcel$export($424c5cdc8cac8172$exports, "infoText", function () { return $424c5cdc8cac8172$export$fda920bf43776f02; }, function (v) { return $424c5cdc8cac8172$export$fda920bf43776f02 = v; });
$parcel$export($424c5cdc8cac8172$exports, "overlayShow", function () { return $424c5cdc8cac8172$export$31832b2516c6041f; }, function (v) { return $424c5cdc8cac8172$export$31832b2516c6041f = v; });
$parcel$export($424c5cdc8cac8172$exports, "submit", function () { return $424c5cdc8cac8172$export$853c27de4ce0f746; }, function (v) { return $424c5cdc8cac8172$export$853c27de4ce0f746 = v; });
$parcel$export($424c5cdc8cac8172$exports, "wrapper", function () { return $424c5cdc8cac8172$export$cc74dcc53cfce4eb; }, function (v) { return $424c5cdc8cac8172$export$cc74dcc53cfce4eb = v; });
var $424c5cdc8cac8172$export$c57e90396a5fdda5;
var $424c5cdc8cac8172$export$761099f155521a60;
var $424c5cdc8cac8172$export$c30e453142468ef3;
var $424c5cdc8cac8172$export$80b267e3ef38fe4a;
var $424c5cdc8cac8172$export$1a09c8e9a482a512;
var $424c5cdc8cac8172$export$fd1af5f6d2c0dae1;
var $424c5cdc8cac8172$export$7aec1c0a952f8449;
var $424c5cdc8cac8172$export$493b5823483d2c4e;
var $424c5cdc8cac8172$export$4b66c84692c39e67;
var $424c5cdc8cac8172$export$8b9bf0a5c2438d10;
var $424c5cdc8cac8172$export$6210fa4921d2a466;
var $424c5cdc8cac8172$export$fda920bf43776f02;
var $424c5cdc8cac8172$export$31832b2516c6041f;
var $424c5cdc8cac8172$export$853c27de4ce0f746;
var $424c5cdc8cac8172$export$cc74dcc53cfce4eb;
$424c5cdc8cac8172$export$c57e90396a5fdda5 = `Jyl0gq_calendarCard`;
$424c5cdc8cac8172$export$761099f155521a60 = `Jyl0gq_calendarContainer`;
$424c5cdc8cac8172$export$c30e453142468ef3 = `Jyl0gq_calendarWrapper`;
$424c5cdc8cac8172$export$80b267e3ef38fe4a = `Jyl0gq_contentShow`;
$424c5cdc8cac8172$export$80b267e3ef38fe4a;
$424c5cdc8cac8172$export$1a09c8e9a482a512 = `Jyl0gq_dialogContent`;
$424c5cdc8cac8172$export$fd1af5f6d2c0dae1 = `Jyl0gq_dialogOverlay`;
$424c5cdc8cac8172$export$7aec1c0a952f8449 = `Jyl0gq_errorForm`;
$424c5cdc8cac8172$export$493b5823483d2c4e = `Jyl0gq_errorMessage`;
$424c5cdc8cac8172$export$4b66c84692c39e67 = `Jyl0gq_errorMessageDescription`;
$424c5cdc8cac8172$export$8b9bf0a5c2438d10 = `Jyl0gq_errorMessageTitle`;
$424c5cdc8cac8172$export$6210fa4921d2a466 = `Jyl0gq_form`;
$424c5cdc8cac8172$export$fda920bf43776f02 = `Jyl0gq_infoText`;
$424c5cdc8cac8172$export$31832b2516c6041f = `Jyl0gq_overlayShow`;
$424c5cdc8cac8172$export$31832b2516c6041f;
$424c5cdc8cac8172$export$853c27de4ce0f746 = `Jyl0gq_submit`;
$424c5cdc8cac8172$export$cc74dcc53cfce4eb = `Jyl0gq_wrapper`;



var $kseh8 = parcelRequire("kseh8");

var $c143V = parcelRequire("c143V");

var $3wjC7 = parcelRequire("3wjC7");

var $1pSdt = parcelRequire("1pSdt");
function $ff0a17b82568f297$export$b37f2c7dc12a79b6({ icon: icon, className: className = "", label: label }) {
    return /*#__PURE__*/ (0, $kseh8.jsxs)("label", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($c143V)))((0, (/*@__PURE__*/$parcel$interopDefault($3wjC7))).wrapper, className),
        children: [
            icon && /*#__PURE__*/ (0, $kseh8.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($3wjC7))).icon,
                children: icon
            }),
            /*#__PURE__*/ (0, $kseh8.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($3wjC7))).group,
                children: [
                    /*#__PURE__*/ (0, $kseh8.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($3wjC7))).label,
                        children: label
                    }),
                    /*#__PURE__*/ (0, $kseh8.jsxs)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($3wjC7))).loader,
                        children: [
                            /*#__PURE__*/ (0, $kseh8.jsx)((0, $1pSdt.SpinnerIcon), {}),
                            " \u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430..."
                        ]
                    })
                ]
            })
        ]
    });
}


// Поле "Гости"
function $faace824f1a88310$var$TextFieldRooms({ onMouseDown: onMouseDown }) {
    return /*#__PURE__*/ (0, $kseh8.jsx)((0, $ff0a17b82568f297$export$b37f2c7dc12a79b6), {
        icon: /*#__PURE__*/ (0, $kseh8.jsx)((0, $c9Xf9.PersonIcon), {}),
        label: "\u0413\u043E\u0441\u0442\u0438",
        onMouseDown: onMouseDown
    });
}
// Поле "Дата Выезда"
function $faace824f1a88310$var$TextFieldTo({ onMouseDown: onMouseDown }) {
    return /*#__PURE__*/ (0, $kseh8.jsx)((0, $ff0a17b82568f297$export$b37f2c7dc12a79b6), {
        icon: /*#__PURE__*/ (0, $kseh8.jsx)((0, $c9Xf9.CalendarIcon), {}),
        label: "\u0412\u044B\u0435\u0437\u0434"
    });
}
// Поле "Дата Заезда"
function $faace824f1a88310$var$TextFieldFrom({ onMouseDown: onMouseDown }) {
    return /*#__PURE__*/ (0, $kseh8.jsx)((0, $ff0a17b82568f297$export$b37f2c7dc12a79b6), {
        icon: /*#__PURE__*/ (0, $kseh8.jsx)((0, $c9Xf9.CalendarIcon), {}),
        label: "\u0417\u0430\u0435\u0437\u0434"
    });
}
function $faace824f1a88310$export$f0cb755d270fc817({ children: children }) {
    return /*#__PURE__*/ (0, $kseh8.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($424c5cdc8cac8172$exports))).wrapper,
        children: /*#__PURE__*/ (0, $kseh8.jsxs)("form", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($424c5cdc8cac8172$exports))).form,
            onSubmit: (e)=>e.preventDefault(),
            children: [
                /*#__PURE__*/ (0, $kseh8.jsx)($faace824f1a88310$var$TextFieldFrom, {}),
                /*#__PURE__*/ (0, $kseh8.jsx)($faace824f1a88310$var$TextFieldTo, {}),
                /*#__PURE__*/ (0, $kseh8.jsx)($faace824f1a88310$var$TextFieldRooms, {}),
                /*#__PURE__*/ (0, $kseh8.jsxs)("button", {
                    color: "dark",
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($424c5cdc8cac8172$exports))).submit,
                    children: [
                        /*#__PURE__*/ (0, $kseh8.jsx)((0, $c9Xf9.MagnifyingGlassIcon), {}),
                        " \u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430...  "
                    ]
                })
            ]
        })
    });
}



var $kseh8 = parcelRequire("kseh8");

var $8pGV4 = parcelRequire("8pGV4");

var $kDUKj = parcelRequire("kDUKj");
var $8CyBf = parcelRequire("8CyBf");

var $4CZ31 = parcelRequire("4CZ31");

var $3oKwh = parcelRequire("3oKwh");

var $c9Xf9 = parcelRequire("c9Xf9");

var $6cSp6 = parcelRequire("6cSp6");


var $2PFJH = parcelRequire("2PFJH");

var $2i6uE = parcelRequire("2i6uE");

var $4QCRh = parcelRequire("4QCRh");

var $iib5s = parcelRequire("iib5s");

var $6xiFT = parcelRequire("6xiFT");

var $5z1Ik = parcelRequire("5z1Ik");

var $8pGV4 = parcelRequire("8pGV4");
function $644517148e5a386d$export$6a7b0335c5fca543(src, dateFrom, dateTo, rooms, timeSettings) {
    const url = new URL(src);
    url.searchParams.append("dateFrom", dateFrom);
    url.searchParams.append("dateTo", dateTo);
    url.searchParams.append("rooms", JSON.stringify(rooms));
    url.searchParams.append("timeSettings", JSON.stringify(timeSettings));
    const module = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8pGV4))).createElement("iframe", {
        src: url,
        className: "lv-booking-module",
        id: "lv-booking-module"
    });
    return module;
}



// Поле "Гости"
function $6b106456bac8e99f$var$TextFieldRooms({ rooms: rooms, onMouseDown: onMouseDown }) {
    const adultsCount = rooms.reduce((sum, current)=>+sum + +current.adults, 0);
    const childsCount = rooms.reduce((sum, current)=>+sum + +current.childrens.length, 0);
    return /*#__PURE__*/ (0, $kseh8.jsx)((0, $2i6uE.WidjetInput), {
        icon: /*#__PURE__*/ (0, $kseh8.jsx)((0, $c9Xf9.PersonIcon), {}),
        label: "\u0413\u043E\u0441\u0442\u0438",
        inputProps: {
            value: `${adultsCount} ${adultsCount > 1 ? "\u0432\u0437\u0440\u043E\u0441\u043B\u044B\u0445" : "\u0432\u0437\u0440\u043E\u0441\u043B\u044B\u0439"}, ${childsCount} ${childsCount <= 1 && childsCount !== 0 ? "\u0440\u0435\u0431\u0435\u043D\u043E\u043A" : "\u0434\u0435\u0442\u0435\u0439"}`,
            placeholder: "\u0413\u043E\u0441\u0442\u0438",
            readOnly: true,
            type: "text"
        },
        onMouseDown: onMouseDown,
        id: "booking-rooms-field"
    });
}
// Поле "Дата Выезда"
function $6b106456bac8e99f$var$TextFieldTo({ value: value, onMouseDown: onMouseDown }) {
    return /*#__PURE__*/ (0, $kseh8.jsx)((0, $2i6uE.WidjetInput), {
        icon: /*#__PURE__*/ (0, $kseh8.jsx)((0, $c9Xf9.CalendarIcon), {}),
        label: "\u0412\u044B\u0435\u0437\u0434",
        inputProps: {
            value: value,
            placeholder: "\u0412\u044B\u0435\u0437\u0434",
            readOnly: true,
            type: "text"
        },
        onMouseDown: onMouseDown,
        id: "booking-to-field"
    });
}
// Поле "Дата Заезда"
function $6b106456bac8e99f$var$TextFieldFrom({ value: value, onMouseDown: onMouseDown }) {
    return /*#__PURE__*/ (0, $kseh8.jsx)((0, $2i6uE.WidjetInput), {
        icon: /*#__PURE__*/ (0, $kseh8.jsx)((0, $c9Xf9.CalendarIcon), {}),
        label: "\u0417\u0430\u0435\u0437\u0434",
        inputProps: {
            value: value,
            placeholder: "\u0417\u0430\u0435\u0437\u0434",
            readOnly: true,
            type: "text"
        },
        onMouseDown: onMouseDown,
        id: "booking-from-field"
    });
}
function $6b106456bac8e99f$export$511301e5919f9ef5({ setIsModuleOpen: setIsModuleOpen, setModuleIframe: setModuleIframe, setIsFailed: setIsFailed }) {
    const store = (0, $8pGV4.useContext)((0, $5z1Ik.WidjetContext));
    const dateFrom = (0, $4QCRh.useStore)(store, (state)=>state.dateFrom);
    const setDateFrom = (0, $4QCRh.useStore)(store, (state)=>state.setDateFrom);
    const dateTo = (0, $4QCRh.useStore)(store, (state)=>state.dateTo);
    const setDateTo = (0, $4QCRh.useStore)(store, (state)=>state.setDateTo);
    const rooms = (0, $4QCRh.useStore)(store, (state)=>state.rooms);
    const setRooms = (0, $4QCRh.useStore)(store, (state)=>state.setRooms);
    const roomsLimits = (0, $4QCRh.useStore)(store, (state)=>state.roomsLimits);
    const [month, setMonth] = (0, $8pGV4.useState)(new Date(new Date(new Date().setDate(1)).setHours(0, 0, 0, 0)));
    const monthFrom = new Date(new Date(new Date().setDate(1)).setHours(0, 0, 0, 0));
    const [mode, setMode] = (0, $8pGV4.useState)("from");
    const [range, setRange] = (0, $8pGV4.useState)({
        from: dateFrom,
        to: dateTo
    });
    const [prices, setPrices] = (0, $8pGV4.useState)(new Map());
    const [uploadedMonth, setUploadedMonth] = (0, $8pGV4.useState)(new Set());
    const [numberOfMonths, setNumberOfMonths] = (0, $8pGV4.useState)(2);
    (0, $8pGV4.useEffect)(()=>{
        if (range.from !== null && range.to !== null) {
            setDateFrom(range.from);
            setDateTo(range.to);
        }
    }, [
        range,
        setDateFrom,
        setDateTo
    ]);
    const [closedForArrival, setClosedForArrival] = (0, $8pGV4.useState)([]);
    const [closedForDeparture, setClosedForDeparture] = (0, $8pGV4.useState)([]);
    const [minmax, setMinmax] = (0, $8pGV4.useState)([]);
    function uploadPrices() {
        for(let i = 0; i < numberOfMonths; i++){
            const key = new Date(new Date(month).setMonth(month.getMonth() + i));
            if (!uploadedMonth.has((0, $kDUKj.default)(key, "yyyy-MM-dd"))) {
                const from = new Date(key);
                const to = new Date(new Date(new Date(new Date(key).setMonth(key.getMonth() + 1)).setDate(0)).setHours(0, 0, 0, 0));
                (0, $iib5s.getCalendarPrices)((0, $kDUKj.default)(from, "yyyy-MM-dd"), (0, $kDUKj.default)(to, "yyyy-MM-dd")).then((data)=>{
                    setUploadedMonth((um)=>new Set(um).add((0, $kDUKj.default)(key, "yyyy-MM-dd")));
                    const newClosedForArrivalData = data.restrictions?.restriction_data?.closedForArrival;
                    const newClosedForDepartureData = data.restrictions?.restriction_data?.closedForDeparture;
                    const newMinmax = data.restrictions?.minmax;
                    if (newClosedForArrivalData) setClosedForArrival(newClosedForArrivalData);
                    if (newClosedForDepartureData) setClosedForDeparture(newClosedForDepartureData);
                    if (newMinmax) setMinmax(newMinmax);
                    if (!data.prices) return;
                    if (!Array.isArray(data.prices)) data.prices = [
                        data.prices
                    ];
                    data.prices.forEach((item)=>{
                        setPrices((prices)=>{
                            return new Map(prices).set((0, $kDUKj.default)(new Date(new Date(item.Date).setHours(0, 0, 0, 0)), "yyyy-MM-dd"), item.MinPrice);
                        });
                    });
                }).catch(()=>{
                    setIsFailed(true);
                });
            }
        }
    }
    (0, $8pGV4.useEffect)(()=>{
        uploadPrices();
    // eslint-disable-next-line
    }, [
        month,
        numberOfMonths
    ]);
    function updatePrices() {
        setPrices(new Map());
        setUploadedMonth(new Set());
        uploadPrices();
    }
    const [calendarOpen, setCalendarOpen] = (0, $8pGV4.useState)(false);
    // Размер экрана
    const size = (0, $6cSp6.default)();
    const [roomsOpen, setRoomsOpen] = (0, $8pGV4.useState)(false);
    // Отключаем действие по умолчанию при клике на поля (действие по умолчанию - закрытие поповера)
    function preventInteractOutside(e) {
        let ids = [
            "booking-from-field",
            "booking-to-field",
            "booking-rooms-field"
        ];
        if (ids.includes(e.target.id) || e.target.closest(ids.map((item)=>`#${item}`))) e.preventDefault();
    }
    // Нажатие на инпут выезда
    function mouseDownToFieldHandler() {
        setRange({
            from: dateFrom,
            to: dateTo
        });
        calendarOpen;
        setNumberOfMonths(2);
        if (mode === "from") setCalendarOpen(true);
        else setCalendarOpen(!calendarOpen);
        if ((0, $8CyBf.default)(dateTo)) setMonth(size.width > 768 ? new Date(new Date(new Date(dateTo).setDate(1)).setHours(0, 0, 0, 0)) : monthFrom);
        setMode("to");
    }
    function clickHandler(day) {
        if (mode === "from") {
            setRange({
                from: day,
                to: null
            });
            setMode("to");
        } else if (mode === "to") {
            if (day.getTime() < range.from?.getTime()) setRange((range)=>({
                    from: day,
                    to: null
                }));
            else if (day.getTime() !== range.from?.getTime()) {
                setRange((range)=>({
                        ...range,
                        to: day
                    }));
                setCalendarOpen(false);
            }
        }
    }
    // Нажатие на инпут въезда
    function mouseDownFromFiledHandler() {
        setRange({
            from: dateFrom,
            to: dateTo
        });
        calendarOpen;
        setNumberOfMonths(2);
        setCalendarOpen(!calendarOpen);
        if ((0, $8CyBf.default)(dateFrom) && (0, $8CyBf.default)(dateTo)) setMonth(size.width > 768 ? new Date(new Date(new Date(dateFrom).setDate(1)).setHours(0, 0, 0, 0)) : monthFrom);
        setMode("from");
    }
    // Проверяем форму и открываем модуль бронирования - "/module/booking/rooms"
    function sumbitHandler(e) {
        e.preventDefault();
        function validate() {
            // Проверка на незаполненного ребенка
            if (rooms.find((item)=>item.childrens.filter((children)=>children === "").length !== 0)) {
                setRoomsOpen(true);
                return false;
            }
            return true;
        }
        if (validate()) {
            setModuleIframe((0, $644517148e5a386d$export$6a7b0335c5fca543)("https://hotelvoda.ru/module", dateFrom, dateTo, rooms, timeSettings));
            window.history.replaceState({
                ...window.history.state,
                lv_module_open: false
            }, "", window.location.href);
            window.history.pushState({
                ...window.history.state,
                lv_module_open: true
            }, "", window.location.href);
            setIsModuleOpen(true);
        }
    }
    const timeSettings = (0, $4QCRh.useStore)(store, (state)=>state.timeSettings);
    if (prices.size === 0) return /*#__PURE__*/ (0, $kseh8.jsx)((0, $faace824f1a88310$export$f0cb755d270fc817), {});
    return /*#__PURE__*/ (0, $kseh8.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($424c5cdc8cac8172$exports))).wrapper,
        children: /*#__PURE__*/ (0, $kseh8.jsxs)("form", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($424c5cdc8cac8172$exports))).form,
            onSubmit: sumbitHandler,
            children: [
                size.width < 768 ? /*#__PURE__*/ (0, $kseh8.jsxs)((0, $kseh8.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $kseh8.jsx)($6b106456bac8e99f$var$TextFieldFrom, {
                            value: (0, $kDUKj.default)(dateFrom, "dd.MM.yyyy"),
                            onMouseDown: mouseDownFromFiledHandler
                        }),
                        /*#__PURE__*/ (0, $kseh8.jsx)($6b106456bac8e99f$var$TextFieldTo, {
                            value: (0, $kDUKj.default)(dateTo, "dd.MM.yyyy"),
                            onMouseDown: mouseDownToFieldHandler
                        }),
                        /*#__PURE__*/ (0, $kseh8.jsx)($3oKwh.Root, {
                            open: calendarOpen,
                            onOpenChange: (state)=>{
                                setNumberOfMonths(2);
                                setCalendarOpen(state);
                            },
                            children: /*#__PURE__*/ (0, $kseh8.jsxs)($3oKwh.Portal, {
                                children: [
                                    /*#__PURE__*/ (0, $kseh8.jsx)($3oKwh.Overlay, {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($424c5cdc8cac8172$exports))).dialogOverlay
                                    }),
                                    /*#__PURE__*/ (0, $kseh8.jsx)($3oKwh.Content, {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($424c5cdc8cac8172$exports))).dialogContent,
                                        children: /*#__PURE__*/ (0, $kseh8.jsx)((0, $6xiFT.Calendar), {
                                            month: month,
                                            setMonth: setMonth,
                                            monthFrom: monthFrom,
                                            numberOfMonths: numberOfMonths,
                                            setNumberOfMonths: setNumberOfMonths,
                                            mode: mode,
                                            setMode: setMode,
                                            range: range,
                                            setRange: setRange,
                                            uploadedMonth: uploadedMonth,
                                            prices: prices,
                                            clickHandler: clickHandler,
                                            description: `\u{426}\u{435}\u{43D}\u{430} \u{443}\u{43A}\u{430}\u{437}\u{430}\u{43D}\u{430} \u{437}\u{430} \u{441}\u{430}\u{43C}\u{44B}\u{439} \u{434}\u{435}\u{448}\u{435}\u{432}\u{44B}\u{439} \u{434}\u{43E}\u{441}\u{442}\u{443}\u{43F}\u{43D}\u{44B}\u{439} \u{43D}\u{43E}\u{43C}\u{435}\u{440} \u{431}\u{435}\u{437} \u{434}\u{43E}\u{43F}\u{43E}\u{43B}\u{43D}\u{438}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{44B}\u{445} \u{43C}\u{435}\u{441}\u{442}`,
                                            timeSettings: timeSettings,
                                            closedForArrival: closedForArrival,
                                            closedForDeparture: closedForDeparture,
                                            minmax: minmax
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                }) : /*#__PURE__*/ (0, $kseh8.jsxs)($4CZ31.Root, {
                    open: calendarOpen,
                    onOpenChange: (state)=>setCalendarOpen(state),
                    align: "bottom",
                    children: [
                        /*#__PURE__*/ (0, $kseh8.jsx)($6b106456bac8e99f$var$TextFieldFrom, {
                            value: (0, $kDUKj.default)(dateFrom, "dd.MM.yyyy"),
                            onMouseDown: mouseDownFromFiledHandler
                        }),
                        /*#__PURE__*/ (0, $kseh8.jsx)($4CZ31.Anchor, {
                            style: {
                                position: "absolute",
                                left: "50%"
                            }
                        }),
                        /*#__PURE__*/ (0, $kseh8.jsx)($6b106456bac8e99f$var$TextFieldTo, {
                            value: (0, $kDUKj.default)(dateTo, "dd.MM.yyyy"),
                            onMouseDown: mouseDownToFieldHandler
                        }),
                        /*#__PURE__*/ (0, $kseh8.jsx)($4CZ31.Portal, {
                            children: /*#__PURE__*/ (0, $kseh8.jsx)($4CZ31.Content, {
                                side: "top",
                                onFocusOutside: preventInteractOutside,
                                onInteractOutside: preventInteractOutside,
                                updatePositionStrategy: "always",
                                children: /*#__PURE__*/ (0, $kseh8.jsx)("div", {
                                    style: {
                                        marginBottom: 16
                                    },
                                    children: /*#__PURE__*/ (0, $kseh8.jsx)((0, $6xiFT.Calendar), {
                                        month: month,
                                        setMonth: setMonth,
                                        monthFrom: monthFrom,
                                        numberOfMonths: numberOfMonths,
                                        setNumberOfMonths: setNumberOfMonths,
                                        mode: mode,
                                        setMode: setMode,
                                        range: range,
                                        setRange: setRange,
                                        uploadedMonth: uploadedMonth,
                                        prices: prices,
                                        clickHandler: clickHandler,
                                        description: `\u{426}\u{435}\u{43D}\u{430} \u{443}\u{43A}\u{430}\u{437}\u{430}\u{43D}\u{430} \u{437}\u{430} \u{441}\u{430}\u{43C}\u{44B}\u{439} \u{434}\u{435}\u{448}\u{435}\u{432}\u{44B}\u{439} \u{434}\u{43E}\u{441}\u{442}\u{443}\u{43F}\u{43D}\u{44B}\u{439} \u{43D}\u{43E}\u{43C}\u{435}\u{440} \u{431}\u{435}\u{437} \u{434}\u{43E}\u{43F}\u{43E}\u{43B}\u{43D}\u{438}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{44B}\u{445} \u{43C}\u{435}\u{441}\u{442}`,
                                        timeSettings: timeSettings,
                                        closedForArrival: closedForArrival,
                                        closedForDeparture: closedForDeparture,
                                        minmax: minmax
                                    })
                                })
                            })
                        })
                    ]
                }),
                size.width < 768 ? /*#__PURE__*/ (0, $kseh8.jsxs)((0, $kseh8.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $kseh8.jsx)($6b106456bac8e99f$var$TextFieldRooms, {
                            rooms: rooms,
                            onMouseDown: ()=>setRoomsOpen(!roomsOpen)
                        }),
                        /*#__PURE__*/ (0, $kseh8.jsx)($3oKwh.Root, {
                            open: roomsOpen,
                            onOpenChange: (state)=>setRoomsOpen(state),
                            children: /*#__PURE__*/ (0, $kseh8.jsxs)($3oKwh.Portal, {
                                children: [
                                    /*#__PURE__*/ (0, $kseh8.jsx)($3oKwh.Overlay, {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($424c5cdc8cac8172$exports))).dialogOverlay
                                    }),
                                    /*#__PURE__*/ (0, $kseh8.jsx)($3oKwh.Content, {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($424c5cdc8cac8172$exports))).dialogContent,
                                        children: /*#__PURE__*/ (0, $kseh8.jsx)((0, $2PFJH.RoomsPicker), {
                                            state: rooms,
                                            setState: setRooms,
                                            limits: roomsLimits,
                                            setOpen: setRoomsOpen
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                }) : /*#__PURE__*/ (0, $kseh8.jsxs)($4CZ31.Root, {
                    open: roomsOpen,
                    onOpenChange: (state)=>setRoomsOpen(state),
                    children: [
                        /*#__PURE__*/ (0, $kseh8.jsx)($4CZ31.Anchor, {
                            children: /*#__PURE__*/ (0, $kseh8.jsx)($6b106456bac8e99f$var$TextFieldRooms, {
                                rooms: rooms,
                                onMouseDown: ()=>setRoomsOpen(!roomsOpen)
                            })
                        }),
                        /*#__PURE__*/ (0, $kseh8.jsx)($4CZ31.Content, {
                            side: "top",
                            onFocusOutside: preventInteractOutside,
                            onInteractOutside: preventInteractOutside,
                            updatePositionStrategy: "always",
                            children: /*#__PURE__*/ (0, $kseh8.jsx)("div", {
                                style: {
                                    marginBottom: 16
                                },
                                children: /*#__PURE__*/ (0, $kseh8.jsx)((0, $2PFJH.RoomsPicker), {
                                    state: rooms,
                                    setState: setRooms,
                                    limits: roomsLimits,
                                    setOpen: setRoomsOpen
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $kseh8.jsxs)("button", {
                    color: "dark",
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($424c5cdc8cac8172$exports))).submit,
                    children: [
                        /*#__PURE__*/ (0, $kseh8.jsx)((0, $c9Xf9.MagnifyingGlassIcon), {}),
                        " \u041D\u0430\u0439\u0442\u0438"
                    ]
                })
            ]
        })
    });
}



var $4QCRh = parcelRequire("4QCRh");
function $36ab63ec67560730$export$8547d86aa42a4780() {
    return fetch(`${"https://booking.hotelvoda.ru/wp-json/booking/v1"}/booking/time`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json"
        }
    }).then((response)=>response.json()).then((data)=>{
        if (data.success) return data;
        else throw new Error("\u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0435 \u043C\u043E\u0434\u0443\u043B\u044F \u0431\u0440\u043E\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F.");
    });
}



var $5z1Ik = parcelRequire("5z1Ik");

var $8Bk0i = parcelRequire("8Bk0i");

var $6spUH = parcelRequire("6spUH");

var $kseh8 = parcelRequire("kseh8");

var $c9Xf9 = parcelRequire("c9Xf9");


var $c143V = parcelRequire("c143V");
function $4c707a2440b2d661$export$492376e2ed4493f2({ callback: callback }) {
    return /*#__PURE__*/ (0, $kseh8.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($424c5cdc8cac8172$exports))).wrapper,
        children: /*#__PURE__*/ (0, $kseh8.jsxs)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($c143V)))((0, (/*@__PURE__*/$parcel$interopDefault($424c5cdc8cac8172$exports))).form, (0, (/*@__PURE__*/$parcel$interopDefault($424c5cdc8cac8172$exports))).errorForm),
            children: [
                /*#__PURE__*/ (0, $kseh8.jsxs)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($424c5cdc8cac8172$exports))).errorMessage,
                    children: [
                        /*#__PURE__*/ (0, $kseh8.jsx)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($424c5cdc8cac8172$exports))).errorMessageTitle,
                            children: "\u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0435 \u043C\u043E\u0434\u0443\u043B\u044F"
                        }),
                        /*#__PURE__*/ (0, $kseh8.jsx)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($424c5cdc8cac8172$exports))).errorMessageDescription,
                            children: "\u041F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u043F\u0435\u0440\u0435\u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u043C\u043E\u0434\u0443\u043B\u044C \u043D\u0430\u0436\u0430\u0432 \u043D\u0430 \u043A\u043D\u043E\u043F\u043A\u0443 \u043E\u0431\u043D\u043E\u0432\u0438\u0442\u044C"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $kseh8.jsxs)("button", {
                    color: "dark",
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($424c5cdc8cac8172$exports))).submit,
                    onClick: callback,
                    children: [
                        "\u041E\u0431\u043D\u043E\u0432\u0438\u0442\u044C ",
                        /*#__PURE__*/ (0, $kseh8.jsx)((0, $c9Xf9.ReloadIcon), {})
                    ]
                })
            ]
        })
    });
}



var $6ZFaX = parcelRequire("6ZFaX");
function $0aa477fd7f3c5808$export$47b36f5d7d190bbe() {
    const store = (0, $8pGV4.useRef)((0, $6spUH.useWidjetStore)()).current;
    const [loading, setLoading] = (0, $8pGV4.useState)(false);
    const setDateFrom = (0, $4QCRh.useStore)(store, (state)=>state.setDateFrom);
    const setDateTo = (0, $4QCRh.useStore)(store, (state)=>state.setDateTo);
    const setRooms = (0, $4QCRh.useStore)(store, (state)=>state.setRooms);
    const setTimeSettings = (0, $4QCRh.useStore)(store, (state)=>state.setTimeSettings);
    const updateBookingSettings = (0, $4QCRh.useStore)(store, (state)=>state.updateBookingSettings);
    const updateRoomsLimits = (0, $4QCRh.useStore)(store, (state)=>state.updateRoomsLimits);
    const isFailed = (0, $4QCRh.useStore)(store, (state)=>state.isFailed);
    const setIsFailed = (0, $4QCRh.useStore)(store, (state)=>state.setIsFailed);
    const dateFrom = (0, $4QCRh.useStore)(store, (state)=>state.dateFrom);
    const dateTo = (0, $4QCRh.useStore)(store, (state)=>state.dateTo);
    const { isModuleOpen: isModuleOpen, setIsModuleOpen: setIsModuleOpen } = (0, $8Bk0i.useBookingModule)();
    (0, $8pGV4.useEffect)(()=>{
        function popstateHandler(e) {
            if (!e.state?.lv_module_open) setIsModuleOpen(false);
        }
        window.addEventListener("popstate", popstateHandler);
        return ()=>{
            window.removeEventListener("popstate", popstateHandler);
        };
    }, [
        isModuleOpen,
        setIsModuleOpen
    ]);
    const uploadSettings = (0, $8pGV4.useCallback)(()=>{
        (0, $36ab63ec67560730$export$8547d86aa42a4780)().then((data)=>{
            const offsetDiff = new Date().getTimezoneOffset() + data.offset;
            const today = new Date(new Date().getTime() + offsetDiff * 60000);
            setTimeSettings(data);
            let df = new Date(new Date(today).setHours(0, 0, 0, 0));
            let dt = new Date(new Date(new Date(today.getTime() + 86400000)).setHours(0, 0, 0, 0));
            if (!dateFrom || !dateTo) {
                setDateFrom(df);
                setDateTo(dt);
            } else if (df.getTime() > dateFrom.getTime() || dt.getTime() > dateTo.getTime()) {
                setDateFrom(df);
                setDateTo(dt);
            }
        }).then(()=>updateBookingSettings()).then(()=>updateRoomsLimits()).then(()=>setLoading(true)).catch(()=>{
            setIsFailed(true);
        });
    }, [
        setDateFrom,
        setDateTo,
        setTimeSettings,
        updateRoomsLimits,
        updateBookingSettings,
        setIsFailed
    ]);
    (0, $8pGV4.useEffect)(()=>{
        uploadSettings();
    }, [
        uploadSettings
    ]);
    const [moduleIframe, setModuleIframe] = (0, $8pGV4.useState)(null);
    function refreshCb() {
        setLoading(false);
        setIsFailed(false);
        uploadSettings();
    }
    (0, $8pGV4.useEffect)(()=>{
        function messageHandler(e) {
            if (e.data.method === "redirect") window.location.replace(e.data.paymentURL);
            else if (e.origin === "https://hotelvoda.ru") {
                if (e.data.dateFrom && e.data.dateTo && e.data.rooms) {
                    setDateFrom(new Date(e.data.dateFrom));
                    setDateTo(new Date(e.data.dateTo));
                    setRooms(e.data.rooms);
                }
            }
        }
        window.addEventListener("message", messageHandler);
        return ()=>{
            window.removeEventListener("message", messageHandler);
        };
    }, []);
    return /*#__PURE__*/ (0, $kseh8.jsxs)((0, $5z1Ik.WidjetContext).Provider, {
        value: store,
        children: [
            loading && !isFailed ? /*#__PURE__*/ (0, $kseh8.jsx)((0, $6b106456bac8e99f$export$511301e5919f9ef5), {
                setIsModuleOpen: setIsModuleOpen,
                setModuleIframe: setModuleIframe,
                setIsFailed: setIsFailed
            }) : "",
            !loading && !isFailed ? /*#__PURE__*/ (0, $kseh8.jsx)((0, $faace824f1a88310$export$f0cb755d270fc817), {}) : "",
            isFailed ? /*#__PURE__*/ (0, $kseh8.jsx)((0, $4c707a2440b2d661$export$492376e2ed4493f2), {
                callback: refreshCb
            }) : "",
            isModuleOpen && /*#__PURE__*/ (0, $6ZFaX.createPortal)(moduleIframe, document.body, "bm-widjet-module")
        ]
    });
}


const $2fc1347197445f0f$var$root = (0, $7D21u.createRoot)(document.getElementById("booking-widjet"));
$2fc1347197445f0f$var$root.render(/*#__PURE__*/ (0, $kseh8.jsx)((0, $0aa477fd7f3c5808$export$47b36f5d7d190bbe), {}));


//# sourceMappingURL=widjet.b38ecb68.js.map
